<template>
    <div class="houseMIBReport">
        ====================》这是houseMIBReport页
    </div>
</template>
<script>
export default {
    name:'houseMIBReport',
      data() {
        return {
        
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// houseMIBReport.vue?9635e262